/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { EntityType } from 'embercom/models/data/entity-types';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';

export interface SimpleDeployStartedWireFormat {
  renderable_type: RenderableType;
}

export default class SimpleDeployStarted {
  readonly renderableType: RenderableType = RenderableType.SimpleDeployStarted;

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(): SimpleDeployStarted {
    return new SimpleDeployStarted();
  }
}
